import AiGeneralBody from './AiGeneralBody';

export default function AiFloatingPanel({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  if (!open) return null;
  return (
    <div className="floating-panel ai">
      <div className="floating-head" style={{ background: 'var(--c-terracotta)' }}>
        <span>Assistant IA · général</span>
        <button className="icon-btn" onClick={onClose} style={{ color: '#fff' }}>
          ×
        </button>
      </div>
      <AiGeneralBody />
    </div>
  );
}
